import { PATH } from './const';
import {useApiCreate} from "../../../../../../lib/HttpService";
import {StubbornPlugin} from "../../../../../../application/business/StubbornConfiguration";

export const useEditionPluginCreate = <T extends StubbornPlugin = StubbornPlugin>() => useApiCreate<T>(PATH);
